import { Divider } from "@mui/material";
import { Stack } from "@mui/system";
import { CustomLabel } from "components/shared";
import { CardMenu } from "components/shared/card_menu";
import { ROUTES } from "routes/constants";
import { useLocation } from "react-router-dom";

const getIncludeCifaRoute = (ano: number) => ROUTES[`INCLUDE_CIFA_${ano}` as keyof typeof ROUTES] as string;
const getViewCifaRoute = (ano: number) => ROUTES[`VIEW_CIFA_${ano}` as keyof typeof ROUTES] as string;

export default function MunicipalManagerCifa(): JSX.Element {
  const location = useLocation();
  const match = /cifa-(\d{4})/.exec(location.pathname);
  const anoReferencia = match ? Number(match[1]) : 2026;

  return (
    <Stack mt='32px' paddingX='384px' spacing='1rem'>
      <CustomLabel
        text={`Gerenciar CIFA - ${anoReferencia}`}
        labelStyle={{
          fontFamily: 'Roboto',
          fontSize: '22px',
          fontWeight: 500,
          letterSpacing: '0.15px',
          lineHeight: '35.2px',
          textAlign: 'left',
        }}
      />

      <Divider />

      <CardMenu
        title={`Cadastrar Município - ${anoReferencia}`}
        description='Realize a Inclusão do Município no Cadastro do Índice Municipal de Agricultura Familiar.'
        pathTo={getIncludeCifaRoute(anoReferencia)}
      />

      <Divider />

      <CardMenu
        title={`Alterar Município - ${anoReferencia}`}
        description='Atualize os dados do Município no Cadastro do Índice Municipal de Agricultura Familiar'
        pathTo={getIncludeCifaRoute(anoReferencia)}
        navigateOptions={{ state: { mode: "edit" } }}
      />

      <Divider />

      <CardMenu
        title={`Visualizar Cadastro do Município - ${anoReferencia}`}
        description='Veja os dados do Município no Cadastro do Índice Municipal de Agricultura Familiar.'
        pathTo={getViewCifaRoute(anoReferencia)}
      />
    </Stack>
  )
}
